import localForage from 'localforage';
import { observable, computed, autorun } from 'mobx';
import { now } from 'mobx-utils';

import rankingStore from './ranking';

class User {
  constructor() {
    localForage.config({
      driver: localForage.INDEXEDDB,
      name: 'localforage',
      storeName: 'keyvaluepairs',
    });

    autorun(() => {
      now(1500);
      this.updateStore();
    });
  }

  @observable
  _db = null;

  @observable
  _score = null;

  @observable
  _user = null;

  @observable
  _country = null;

  @computed
  get score() {
    const score = +this._score;
    if (isNaN(score)) return 0;
    return score;
  }

  updateStore = async () => {
    try {
      this._user = await localForage.getItem('user');
      this._score = await localForage.getItem('score');
      this._country = await localForage.getItem('country');
      // console.log({
      //   user: this._user,
      //   score: this._score,
      //   country: this._country,
      // });
    } catch (e) {}
  };

  fetchDB = async () => {
    try {
      await this.updateStore();
    } catch (e) {
    } finally {
      await rankingStore.fetchRanking();
    }
  };
}

export default new User();
